import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { PaymentService } from '../../pay/services/payment.service';
import { Observable, of } from 'rxjs';
import { LiabilitiesApiService } from '../../dashboard/services/liabilities-api.service';

@Injectable({
  providedIn: 'root',
})
export class BannersFirstDeferral implements CanActivate {


  constructor(private paymentService: PaymentService, private router: Router, private liabilitiesService: LiabilitiesApiService) {
  }

  public canActivate(): boolean | Observable<boolean | UrlTree> {
    return this.paymentService.basePayment$
      .pipe(
        switchMap((basePayment) => {
          if (basePayment?.id) {
            return of(this.router.parseUrl('/liabilities/pay/' + basePayment.id));
          } else {
            return this.liabilitiesService.existsUnpaidLiabilities().pipe(
              switchMap(value => {
                if (value) {
                  return of(this.router.parseUrl('/liabilities/all'));
                } else {
                  return of(this.router.parseUrl('/liabilities/add'));
                }
              }),
            );
          }
        }),
      );
  }

}
